import UnderscoredInput from 'client/common/components/underscored-input';

import './index.css';

export default UnderscoredInput;
